module.exports = __webpack_public_path__ + "static/favicon-341d45a2295277027116b6a865eb45f6.ico";